import { LoadingIndicatorTotalPercent } from '@ohif/ui-next';

export default {
  'ui.loadingIndicatorTotalPercent': LoadingIndicatorTotalPercent,
};
